<template>
	<c-dialog ref="dialog" title="选择优惠券" width="900" @resolve="resolve">
		<c-table ref="table" height="400">
			<c-table-column
				type="selector"
				:multiple="!!multiple"
			></c-table-column>
				
			<c-table-column
				label="优惠券名称"
				name="coupon_name"
				width="140"
			></c-table-column>
			
			<c-table-column
				label="优惠券类型"
				name="coupon_kinds"
			>
				<template v-slot="{data}">
					{{dict.couponType[data.coupon_kinds]}}
				</template>
			</c-table-column>
			
			<c-table-column
				label="优惠力度"
				name="detail"
				width="140"
			></c-table-column>
			
			<c-table-column
				label="适用范围"
				name="commodity_range"
				width="140"
			>
				<template v-slot="{data}">
					{{dict.couponRange[data.commodity_range]}}
				</template>
			</c-table-column>
			
			<c-table-column
				label="发放总量"
				name="available_amount"
				width="80"
			></c-table-column>
			
			<c-table-column
				label="剩余可领"
				name="surplus"
				width="80"
			></c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		props: {
			multiple: Boolean
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		methods: {
			open() {
				this.$refs.dialog.open();
				this.$refs.table.load({
					url: '/couponInfo/list',
					data: {
						state: [2]
					}
				});
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择优惠券'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>